import React from "react";
import BrandList from './BrandList';
import Pagination from './Pagination';
import axios from "axios";
import $ from "jquery";

class Totals extends React.Component {
    render(){
        var currentPageCount = this.props.next + this.props.perPage;
        if(currentPageCount > this.props.count) currentPageCount = this.props.count; //account for half full pages
        return (
            <p><strong>Showing {this.props.next + 1} to {currentPageCount} of {this.props.count} brands</strong></p>
        );
    }
}

class BrandCard extends React.Component{
    render(){
        var action = "dashboard/manage/edit/"+this.props.ID;
        var insights = "/dashboard/brand/insights/"+this.props.ID;
        var image = "/DashboardPage_Controller/BrandImage/"+this.props.ID;
        if(this.props.GlobalView === 1){
            action = "/dashboard/brand/loginAsBrandManager/"+this.props.ID+"?Next="+action;
        }

        return(
            <div className="col brand-card">
                <div className="card">
                    <div className="card-image">
                        <a href={action}><img src={image} className="card-img-top" /></a>
                    </div>
                    <div className="card-body">
                        <a href={action}>
                            <h5 className="card-title">{this.props.Name}</h5>
                            <p className="card-text">
                                {this.props.Type}
                            </p>
                        </a>
                    </div>
                    <br />
                    <div className="card-buttons row">
                        <a href={insights} className="btn btn-primary btn-xs mt-1 waves-effect waves-light float-end">Insights</a>
                        <a href={action} className="btn btn-outline-primary btn-xs mt-1 waves-effect waves-light float-end mr-10">Manage</a>
                    </div>
                </div>
            </div>
        );
    }
}

class BrandsHolderPage extends React.Component {
    constructor(props){
        super(props);
        this.ExportBrandsButton = React.createRef();

        this.state = {
            "allBrands": null, //contains all brands for the business unit
            "matchedBrands": null, //contains brands matched by search criteria
            "types": null,
            "brandsLoaded": false,
            "brandType": null,
            "brandClue": null,//contains the current value of the typeahead
            "brandsCount": null,
            "matchesCount": null,
            "next" : 0,//contains offset for next 11 items eg. 0, 11, 22, 33
            "pagingRefresh": 0,
            "globalView": false
        };
    }

    componentDidMount() {
        this.getBrandTypes();
        this.getBrands();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.state.allBrands && !this.state.brandsLoaded) {
            this.setState({
                brandsLoaded: true,
                brandsCount: Object.keys(this.state.allBrands).length
            });

            var parent = this;
            $("#brand-selector").on( "keyup", function(e){
                parent.onKeyPressed(e.target.value);
            }); 
            $("#brand-type-selector").on( "change", function(e){
                parent.onTypeChanged(e.target.value);
            });      
        } 

        if(prevState.next !== this.state.next) this.getBrands();  
    }

    getBrands(){
        var url = "react/process?endpoint=brands&orderBy=Recent&excludeUmbrella=1&fields=Type,ImageURL,Slug&IgnoreFilters=1&turnoffdebug=1";
        var cacheKey = $(".brandlistcachekey").data("brandlistcachekey");
        if(cacheKey) url += "&cacheKey="+cacheKey;
        if($(".brandlistcachekey").hasClass("global-view")) this.setState({"globalView": true});
        axios.get(url).then(response => this.formatData({"allBrands": response.data.items}));
    }

    getBrandTypes(){
        axios.get("/dashboard/getAllBrandTypes").then(response => this.formatData({"types": response.data}));
    }

    formatData(data){
        this.setState(data);
    }

    onKeyPressed = (clue) => { 
        var brands = (this.state.brandType) ? this.getBrandsByType(this.state.brandType) : this.state.allBrands;
        var matches = this.getBrandsByClue(clue, brands);
        var count = matches ? Object.keys(matches).length : 0;

        this.setState({
            next: 0, //reset totals
            pagingRefresh: Date(),//reset paging
            matchedBrands: matches,
            matchesCount: count,
            brandClue: clue,
        });
    }

    onTypeChanged = (type) => {   
        if(type === "alltypes") type = null;
        var brands = (this.state.brandClue) ? this.getBrandsByClue(this.state.brandClue) : this.state.allBrands;
        var matches = this.getBrandsByType(type, brands);
        var count = matches ? Object.keys(matches).length : 0;

        this.setState({
            next: 0, //reset totals
            pagingRefresh: Date(),//reset paging
            matchedBrands: matches,
            matchesCount: count,
            brandType: type
        });
    }

    getBrandsByClue = (clue, brands) => {
        if(!brands) brands = this.state.allBrands;//passed brands will already be filtered, otherwise use all
        var matches = brands.filter(function(brand){
            return brand.Name.toLowerCase().includes(clue.toLowerCase());
        });
        return matches;
    }

    getBrandsByType = (type, brands) => {
        if(!brands) brands = this.state.allBrands; //passed brands will already be filtered, otherwise use all
        if(!type) return brands; //case where "alltypes" is selected from dropdown
        var matches = brands.filter(function(brand){
            if(brand.Type) return brand.Type.toLowerCase() === type.toLowerCase();
        });
        return matches;
    }

    clearFilters = (e) => {
        e.preventDefault();
        $('#brand-selector').typeahead('val', "");
        $('#brand-type-selector').val("alltypes");

        this.setState({
            brandType: null,
            brandClue: null,
            matchedBrands: null,
            matchesCount: null
        });
    }

    exportBrandList = () => {
        $(this.ExportBrandsButton.current).attr("disabled", "disabled");
        window.location.href = "dashboard/exportBrandList?turnoffdebug=1";
        return;
    }

    paginationHandler(next){
        this.setState({
            next: next,
        });
    }

    render() {
        var brands = {};
        var brandsCount = 0;
        if(this.state.matchedBrands) {
            brands = this.state.matchedBrands;
            brandsCount = this.state.matchesCount;
        } else if(this.state.allBrands) {
            brands = this.state.allBrands;
            brandsCount = this.state.brandsCount;
        }

        const types = this.state.types ? this.state.types : {};
        const globalView = this.state.globalView ? 1 : 0;
        const parent = this;

        //display brands by current page, handles pagination
        if(Object.keys(brands).length > this.props.perPage) {
            brands = brands.slice(this.state.next, (this.state.next + this.props.perPage));
        }

        var filterText = "";
        if(this.state.matchedBrands) filterText += brandsCount+" matching brands";
        else filterText += brandsCount+" total brands (by member activity)";
        if(this.state.brandType) filterText += " filtered by Category: "+this.state.brandType;

        return(
            <div>
                <form>
                    <div className="row mb-3">
                        <label className="col-md-2 col-form-label align-right"> Search for brands:</label>
                        <div className="col-md-3 form-field-height mb-2 brandlist-holder">
                            <BrandList page="BrandsHolderPage" sendToPage={parent.onKeyPressed.bind(this)} />
                        </div>
                        <label className="col-md-2 col-form-label align-right"> Select a brand category:</label>
                        <div className="col-md-3 form-field-height mb-2">
                            <select className="form-select" id="brand-type-selector" data-toggle="select2" multiple="">
                                <option value="alltypes">All categories</option>
                                {Object.entries(types).map(function(obj, key) {
                                   return <option key={key} value={obj[1]}>{obj[1]}</option>;
                                })}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <button className="btn btn-danger mb-3 waves-effect waves-light float-end" 
                                    onClick={(e) => this.clearFilters(e)}>Clear</button>
                        </div>
                        
                    </div>
                </form>

                <div className="row">
                    <div className="col-12">

                        <h5 className="mt-2 mb-3">{filterText}
                            <div className="pull-right">
                                <button className="btn btn btn-secondary export-brand-list" 
                                    ref={this.ExportBrandsButton}
                                    onClick={() => this.exportBrandList()}>
                                    <span class="btn-label"><i class="fas fa-download"></i></span>
                                    Export Brand List</button>
                            </div>
                        </h5>
                        <br />

                        <div className="row row-cols-2 row-cols-lg-6 row-cols-md-4 row-cols-sm-3 g-2 card-overview">

                            <div className="col" style={this.state.globalView ? { display: 'none' } : {}}>
                                <a href="dashboard/manage/edit" className="new-card-link">
                                    <div className="card card-new">
                                        <div className="card-body">
                                            <i className="fas fa-plus-circle"></i>
                                            <br/>Add new brand
                                        </div>
                                    </div>
                                </a>
                            </div>
                                {Object.entries(brands).map(function(obj, key) {
                                   return <BrandCard key={key} ID={obj[1].ID} Name={obj[1].Name} 
                                                     Type={obj[1].Type} GlobalView={globalView} />;
                                })}
                        </div>
                    </div>
                </div>

                <div className="table-controls">
                    <Totals perPage={this.props.perPage} next={this.state.next} count={brandsCount} />
                    <Pagination perPage={this.props.perPage} sendToPage={parent.paginationHandler.bind(this)} 
                                count={brandsCount} refreshToken={this.state.pagingRefresh} />
                </div>    

            </div>
        );
    }
}

BrandsHolderPage.defaultProps = {
    perPage: 11
};

export default BrandsHolderPage;